export const APIURL = "https://api.gabrielny.com:8080/ai_dashboard.php";
export const SOD_APIURL = "https://api.gabrielny.com:8080/ai_dashboard.php";
export const AMAZON_CONNECT_APIURL = "https://api.gabrielny.com:8080/ai_amazonconnect.php";

// Shared CS roster used by Barbara Ryan and Melina Vargas (Manager Level).
// Razmig stays listed so Barbara/Melina still see any CS-tagged GREAT rows;
// his Account Executive rows are owned by Janelle via SUPERVISOR_TEAMS + dept mapping.
const csTeamMembers = [
    { name: "Michelle Araya", email: "maraya@gabrielny.com" },
    { name: "Victoria Gaynor", email: "vgaynor@gabrielny.com" },
    { name: "Willie Nunes", email: "wnunes@gabrielny.com" },
    //{ name: "Willie Nunes", email: "charbel.toumieh@gabrielny.com" },
    { name: "Alexandra Lynn", email: "alynn@gabrielny.com" },
    { name: "Lisa Jones", email: "ljones@gabrielny.com" },
    { name: "Natasha Doobay", email: "natasha.doobay@gabrielny.com" },
    { name: "Darline Nunez", email: "darline.nunez@gabrielny.com" },
    { name: "Walid Azar", email: "walid.azar@gabrielny.com" },
    { name: "Elizabeth Hernandez", email: "ehernandez@gabrielny.com" },
    { name: "Sevag Tashjian", email: "sevag.tashjian@gabrielny.com" },
    { name: "Anthony Saliba", email: "anthony.saliba@gabrielny.com" },
    { name: "Razmig AlMayan", email: "razmig.almayan@gabrielny.com" },
    { name: "Francis", email: "bjesumary@gabrielny.com" }
];

// Shared Custom Order roster used by John Hanna and Tracy Verry (Manager Level).
// Anthony stays listed for pre-2026-04-21 Custom Order visibility (cutover in
// great/index.jsx routes his post-cutover rows to Customer Service).
const customOrderTeamMembers = [
    { name: "Samer Francis", email: "samer.francis@gabrielny.com" },
    { name: "Anthony Saliba", email: "anthony.saliba@gabrielny.com" },
    { name: "Vrej Kendoyan", email: "vrej.kendoyan@gabrielny.com" },
    { name: "Tracy Verry", email: "tverry@gabrielny.com" },
    { name: "Joe Chahwan", email: "joe.chahwan@gabrielny.com" },
    { name: "Heather Poppy", email: "hpoppy@gabrielny.com" },
    { name: "John Bader", email: "john.bader@gabrielny.com" },
    { name: "Joyce Dagher", email: "joyce.dagher@gabrielny.com" }
];

// Shared Concierge roster used by Christine Dahdah and Peter Kurani (Manager Level).
const conciergeTeamMembers = [
    { name: "Jasmine Almayan", email: "jasmine.almayan@gabrielny.com" },
    { name: "Vartan Kaloustian", email: "vartan.kaloustian@gabrielny.com" }
];

// Account Executives under Janelle Fernuik. Belma includes email aliases
// so either known login address grants individual-page access.
const accountExecutiveTeamMembers = [
    { name: "Razmig AlMayan", email: "razmig.almayan@gabrielny.com" },
    { name: "Inderjit Singh", email: "isingh@gabrielny.com" },
    { name: "Belma Yucel", email: "byucel@gabrielny.com" },
    { name: "Belma Yucel", email: "belma@gabrielny.com" },
    { name: "Rachel Hayduk", email: "rhayduk@gabrielny.com" },
    { name: "Emma Lanka", email: "elanka@gabrielny.com" },
    { name: "Janelle Fernuik", email: "jfernuik@gabrielny.com" },
    { name: "Joelle Jreije", email: "joelle.jreije@gabrielny.com" }
];

const johnHannaTeam = {
    supervisorName: "John Hanna",
    teamMembers: customOrderTeamMembers
};

const melinaVargasTeam = {
    supervisorName: "Melina Vargas",
    teamMembers: csTeamMembers
};

const rawSupervisorTeams = {
    // Customer Service managers
    "bryan@gabrielny.com": {
        supervisorName: "Barbara Ryan",
        teamMembers: csTeamMembers
    },
    "mvargas@gabrielny.com": melinaVargasTeam,
    // Alternate Microsoft sign-in UPN (same manager access as mvargas@)
    "melina.vargas@gabrielny.com": melinaVargasTeam,
    // Concierge managers
    "christine.dahdah@gabrielny.com": {
        supervisorName: "Christine Dahdah",
        teamMembers: conciergeTeamMembers
    },
    "peter.kurani@gabrielny.com": {
        supervisorName: "Peter Kurani",
        teamMembers: conciergeTeamMembers
    },
    // Custom Order managers (jhanna is the login email; john.hanna kept as alias)
    "jhanna@gabrielny.com": johnHannaTeam,
    "john.hanna@gabrielny.com": johnHannaTeam,
    "tverry@gabrielny.com": {
        supervisorName: "Tracy Verry",
        teamMembers: customOrderTeamMembers
    },
    // Account Executives (outbound sales) — supervisor is Janelle Fernuik
    "jfernuik@gabrielny.com": {
        supervisorName: "Janelle Fernuik",
        teamMembers: accountExecutiveTeamMembers
    }
};

export const SUPERVISOR_TEAMS = Object.fromEntries(
    Object.entries(rawSupervisorTeams).map(([email, data]) => [
        email.toLowerCase(),
        {
            ...data,
            teamMembers: data.teamMembers.map(member => ({
                ...member,
                email: member.email.toLowerCase()
            }))
        }
    ])
);

// Co-managers who share department visibility when GREAT rows name only one of them.
export const CO_SUPERVISOR_GROUPS = [
    ["Barbara Ryan", "Melina Vargas"],
    ["John Hanna", "Tracy Verry"],
    ["Christine Dahdah", "Peter Kurani"]
];


export const retailrelationsteam = [
    "jchin@gabrielny.com",
    "carl.khoury@gabrielny.com",
    "aandre@gabrielny.com",
    // "rodi.chamii@gabrielny.com",
    "scrowder@gabrielny.com"
].map(e => e.toLowerCase());


export const NLPTEAM = [].map(e => e.toLowerCase());


// Executive Leadership Level — Summary + All Dept. Inbound & Outbound pages.
export const globalAdmins = [
    'dominick@gabrielny.com',
    'jack@gabrielny.com',
    'avance@gabrielny.com',
    'efistani@gabrielny.com',
    'fracioppi@gabrielny.com',
    'Ozde.Sonmez@gabrielny.com',
    'dgabriel@gabrielny.com',
    "charbel.toumieh@gabrielny.com",
    "dhutchinson@gabrielny.com",
    "rodi.chamii@gabrielny.com",
    "jessica.nacouzi@gabrielny.COM",
    "zahi.allam@gabrielny.COM",
    "Anthony.Zakhia@gabrielny.COM",
    "Praveen.Mathew@gabrielny.COM",
    "dalpas@GABRIELNY.COM",
    "jade.elmasri@gabrielny.COM",
    "lpalmer@gabrielny.com",
    "omar.saad@GABRIELNY.COM",
    "simon.haidar@GABRIELNY.COM",
    "raghuraman.kesavan@GABRIELNY.COM",
    "rani.shaar@GABRIELNY.COM",
    "rami.salhab@gabrielny.com",
    "oakintan@gabrielny.com",
    "emile.ambour@GABRIELNY.COM",
    "dalpas@GABRIELNY.COM",
    "asahidha@gabrielny.com"
].map(e => e.toLowerCase());



export const EmberAdmin = [
    "zahi.allam@gabrielny.COM",
    "rodi.chamii@gabrielny.com",
    "dhutchinson@gabrielny.com"
].map(e => e.toLowerCase());
